module.exports = __webpack_public_path__ + "img/1534152965.23311cfa.jpg";